import { render } from "./anc_investigations.vue?vue&type=template&id=7ecb8936&scoped=true"
import script from "./anc_investigations.vue?vue&type=script&lang=js"
export * from "./anc_investigations.vue?vue&type=script&lang=js"

import "./anc_investigations.vue?vue&type=style&index=0&id=7ecb8936&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecb8936"]])

export default __exports__